import React from 'react'
import { Layout, Stack, Card, Button, Text, ButtonGroup } from '@shopify/polaris'

export const SyncSearch = () => {
  return (
    <Layout.Section>
      <Card sectioned>
        <Stack vertical>
          <Text variant="heading2xl" as="h2">
            検索システム(MeiliSearch)との同期
          </Text>
          <Text variant="bodyMd" as="p">
            [同期]ボタンを押すと、検索システムに商品情報を全量同期します。 処理に10分ほどかかります。
          </Text>
          <ButtonGroup>
            <Button submit primary>
              同期
            </Button>
          </ButtonGroup>
        </Stack>
      </Card>
    </Layout.Section>
  )
}
